
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import ElgaPatient from '@/types/soap/elga/Patient';
    import Patient from '@/types/Patient';
    import { confirmSwal } from '@/helper/swals';

    @Component({
        computed: {
            ...mapState('globals', ['formatDate']),
            ...mapState('patient', ['loaders', 'elgaPatienten', 'tempPatientData']),
        },
        methods: {
            ...mapActions('patient', ['saveImpfpass']),
        },
    })
    export default class ElgaPatientSuche extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Patient;

        public patientData = new Patient();
        public curIndex = 0;

        public elgaPatienten!: ElgaPatient[];
        public saveImpfpass!: (payload: { patient: Patient }) => Promise<boolean>;

        @Watch('tempPatientData', { deep: true })
        public onChangeTempPatientData(tempPatientData: Patient): void {
            this.patientData = tempPatientData;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.curIndex = 0;
            }
        }

        public get patient(): ElgaPatient {
            return this.elgaPatienten[this.curIndex] ?? new ElgaPatient();
        }

        public get patientExists(): boolean {
            return !!this.patient.bPK || !!this.patientData?.bpk_gh;
        }

        public onClickSync(): void {
            const patientName = this.patientData.name ?? '';
            const elgaName = this.patient.nachnameVorname;

            const text = `SV-Nr. und Impfungen von ${elgaName} werden für Patient ${patientName} übernommen`;

            confirmSwal(
                'e-Impfpass',
                `${text}. Sind Sie sicher?`,
                'Übernehmen',
                'Abbrechen',
            ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    this.patientData.bpk_gh = this.patient.bPK;
                    this.patientData.svnr = this.patient.ssno;

                    this.saveImpfpass({ patient: this.patientData })
                        .then((success: boolean) => {
                            if (success) {
                                this.$emit('close');
                            }
                        });
                }
            });
        }
    }
